import React, {Component} from 'react';
import {FormattedDate} from 'react-intl';
import {Button} from 'reactstrap/';
import Dialog from 'apa/containers/Dialog';
import autobind from 'autobind-decorator';
import {connect} from 'react-redux';
import * as hours from 'customers/actions/hours'

@connect(
    null,
    dispatch => {
        return {
            remove: hour => dispatch(hours.remove(hour))
        }
    }
)
export default class Hour extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleteHourModalOpen: false
        }
    }

    render() {
        const hour = this.props.hour;
        return (
            <tr>
                <td>
                    <FormattedDate value={hour.created}/>
                </td>
                <td>
                    {hour.hours}
                </td>
                <td>
                    <Button color='danger' onClick={this.toggleDeleteModal}>
                        <i className='fa fa-times'> </i>
                    </Button>
                    <Dialog
                        isOpen={this.state.isDeleteHourModalOpen}
                        toggle={this.toggleDeleteModal}
                        confirm={this.confirmDelete}
                    >
                        Sind Sie Sicher?
                    </Dialog>
                </td>
            </tr>
        )
    }

    @autobind
    toggleDeleteModal() {
        this.setState({
            ...this.state,
            isDeleteHourModalOpen: !this.state.isDeleteHourModalOpen
        })
    }

    @autobind
    confirmDelete() {
        this.props.remove(this.props.hour);
        this.toggleDeleteModal();
    }

}
